module.exports = __webpack_public_path__ + "static/media/impacted.1cde619c.svg";